module.exports = __webpack_public_path__ + "img/discord_icon.bcb77230.svg";